import { tools } from '@/config/tools';
import AppShell from '@/layout/AppShell.vue';
import { createRouter, createWebHistory } from 'vue-router';

const toolRoutes = tools.map((t) => ({
  path: t.route.slice(1),
  name: t.route.slice(1),
  component: t.component,
  meta: { title: t.label, description: t.desc },
}));

const routes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      title: 'Не найдено',
      description: 'Запрашиваемая страница не найдена.',
    },
  },
  {
    path: '/',
    component: AppShell,
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/HomePage.vue'),
        meta: {
          title: 'Главная',
          description:
            'QA.Kit — набор офлайн-утилит для QA-инженеров: JWT, Base64, Hash, JSON, WebSocket, SSE и другие инструменты.',
        },
      },
      {
        path: 'cookies',
        name: 'cookies',
        component: () => import('@/views/CookiePolicy.vue'),
        meta: {
          title: 'Политика cookies',
          description: 'Политика использования файлов cookie на сайте QA.Kit.',
        },
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: () => import('@/views/PrivacyPolicy.vue'),
        meta: {
          title: 'Политика обработки персональных данных',
          description: 'Политика обработки персональных данных в соответствии с ФЗ-152.',
        },
      },
      ...toolRoutes,
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

function setMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.name = name;
    document.head.appendChild(el);
  }
  el.content = content;
}

function setOg(property: string, content: string) {
  let el = document.querySelector(`meta[property="og:${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', `og:${property}`);
    document.head.appendChild(el);
  }
  el.content = content;
}

router.afterEach((to) => {
  const title = to.meta.title as string | undefined;
  const desc = (to.meta.description as string | undefined) ?? '';
  const fullTitle = title ? `${title} — QA.Kit` : 'QA.Kit';

  document.title = fullTitle;
  setMeta('description', desc);
  setOg('title', fullTitle);
  setOg('description', desc);
});

export default router;
